// extracted by mini-css-extract-plugin
export default {"spinner_container":"_1c31","spinner_svg":"dED_","spin":"WJth","spinner":"_2Auj"};